import { Notice } from "@/data/common/notice";
import { DeleteNoticePayload } from "@/data/payload/notice/delete-notice-payload";
import { NoticeRepository } from "@/domain/repository/notice-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeleteNoticeByUuidUsecase {
  constructor(private readonly noticeRepository: NoticeRepository) {}

  async execute(noticeUuid: string, notice: Notice): Promise<SATResult<void, SATError>> {
    const payload: DeleteNoticePayload = {
      notice: {
        boardTitle: notice.boardTitle,
        title: notice.title,
        body: notice.body,
        type: notice.type,
        startViewDate: notice.startViewDate,
        endViewDate: notice.endViewDate,
        appVersion: notice.appVersion,
        isPriority: notice.isPriority,
        priorityNumber: notice.priorityNumber,
        isActive: false,
      },
    };
    const result = await this.noticeRepository.deleteNoticeByUuid(noticeUuid, payload);

    if (result.isSuccess) {
      console.log("[DeleteNoticeByUuidUsecase] :: execute :: 공지사항 삭제 성공");
      return SATResult.success(undefined);
    }

    console.log("[DeleteNoticeByUuidUsecase] :: execute :: 공지사항 삭제 실패", result.error);
    return SATResult.failure(result.error);
  }
}
